// @flow

export const getSanitizedUrl = (url: string) => url.replace('webm', 'mp4');

export const getThumbnail = (url: string) => url.replace(/(movie)(.*)/g, 'movie.293x165.jpg').replace(/^http:\/\//i, 'https://');
